import { axios } from '@/utils/request'

//申请表单相关Api
const logApi = {
  listByRefId: '/api/1/dyvms/log/listByRefId',
  queryDyVmsPushLogVoList: '/api/1/dyvms/log/queryDyVmsPushLogVoList',
}

/**
 * 查询日志列表
 * @param refId
 * @param resourceType
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const ListByRefId = (refId,resourceType) => axios.get(logApi.listByRefId, { params: { refId,resourceType } })
/**
 * 查询推送日志列表
 * @param data
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const QueryDyVmsPushLogVoList = (data) => axios.get(logApi.queryDyVmsPushLogVoList, { params: { ...data } })
